import { jsxs as f, Fragment as B, jsx as o } from "react/jsx-runtime";
import { useCallback as g, useMemo as m, cloneElement as E } from "react";
import { useMultiStyleConfig as L, Link as T, Icon as U, Flex as V, Box as Y } from "@chakra-ui/react";
import { useGlobalNavContext as q } from "./useGlobalNavv2Context.mjs";
import { Typography as w } from "../dataDisplay/Typography/Typography.mjs";
import { ChevronUpIcon as z, ChevronDownIcon as D } from "../icons/componentIcons.mjs";
import { getValidChildren as H } from "../../utils/getValidChildren.mjs";
import "react-nanny";
import { registerChildRef as b, getCategoryClasses as J } from "./globalNavFunctions.mjs";
const re = ({
  icon: x,
  label: I,
  as: N,
  children: d,
  className: j,
  href: p,
  index: h,
  isExternal: G = !1,
  onClick: i,
  onKeyDown: l,
  ...R
}) => {
  const {
    categoryRefs: S,
    globalNavState: r,
    handleCategoryKeyDown: C,
    handleCategorySelect: u,
    isOpen: v,
    linkAs: y,
    rootId: $,
    variant: s
  } = q(), A = L("GlobalNavv2", { variant: s }), e = `${$}__cat${h}`, F = g(
    (a) => {
      b(S, e, a);
    },
    [b, e]
  ), c = m(
    () => e === r.activeCategory,
    [e, r.activeCategory]
  ), n = m(
    () => !!(e === r.openCategory && v),
    [e, r.openCategory, v]
  ), t = m(() => H(d).map((_, k) => E(_, {
    index: k,
    id: e
  })), [d]), M = g(
    (a) => {
      u(a, t), i == null || i(a);
    },
    [u, t]
  ), O = g(
    (a) => {
      C(a, t), l == null || l(a);
    },
    [C, t]
  );
  return /* @__PURE__ */ f(B, { children: [
    /* @__PURE__ */ f(
      T,
      {
        ref: F,
        id: e,
        role: "menuitem",
        as: y || N,
        href: p,
        to: p,
        sx: A.category,
        onClick: M,
        onKeyDown: O,
        tabIndex: r.focusCategory === h ? 0 : -1,
        className: J(c, n, j),
        ...t.length > 0 && { "aria-expanded": !!n },
        ...t.length > 0 && { "aria-haspopup": !0 },
        isExternal: G,
        ...c && r.activeItem === "" && { "aria-current": "page" },
        ...c && r.activeItem !== "" && { title: "Contains current page" },
        ...R,
        children: [
          /* @__PURE__ */ o(U, { children: x }),
          /* @__PURE__ */ o(w, { as: "span", children: I }),
          s === "mobile" && t.length > 0 && /* @__PURE__ */ o(V, { flex: 1, justifyContent: "right", children: n ? /* @__PURE__ */ o(z, { variant: "light" }) : /* @__PURE__ */ o(D, { variant: "light" }) })
        ]
      }
    ),
    s === "mobile" && n && /* @__PURE__ */ o(Y, { paddingY: 2, id: `${e}-panel`, "aria-labelledby": e, role: "menu", children: t })
  ] });
};
export {
  re as GlobalNavv2Category
};
